export default __webpack_public_path__ + "components/page-header/static/icon-down-arrow-f6aa3445f4a7b5ea1ca8f19f1947856e.svg";